
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"stroke",attrs:{"cx":"19","cy":"19","r":"18","stroke":"#A3A3A3","stroke-width":"2"}}),_c('path',{staticClass:"color",attrs:{"d":"M27.55 18.74a.3.3 0 010 .52l-12.6 7.274a.3.3 0 01-.45-.26V11.726a.3.3 0 01.45-.26l12.6 7.275z","fill":"#FFF"}})])
          )
        }
      }
    